import { render, staticRenderFns } from "./StatsModal.vue?vue&type=template&id=aa45e9b4&scoped=true&"
import script from "./StatsModal.vue?vue&type=script&lang=js&"
export * from "./StatsModal.vue?vue&type=script&lang=js&"
import style0 from "./StatsModal.vue?vue&type=style&index=0&id=aa45e9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa45e9b4",
  null
  
)

export default component.exports